<script setup lang="ts">
const props = defineProps<{ name: string }>()

const initials = computed(() => {
  const parts = props.name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2)
    return (parts[0][0] + parts.at(-1)![0]).toUpperCase()

  return props.name.slice(0, 2).toUpperCase()
})
</script>

<template>
  <span class="flex shrink-0 select-none items-center justify-center rounded-full bg-primary text-surface-0 font-bold">
    {{ initials }}
  </span>
</template>
